import { faArrowRight, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import ReactTable from "react-table";
import { Container } from "reactstrap";
import BaseButtonWithIconAndTooltip from "../../../../../toolkit/baseButtonWithIconAndTooltip";
import { ReduxConnect } from "../../../../../toolkit/decorators/Artifact";
import InvitadoDetalle from "../../../../../types/InvitadoDetalle";
import { errorNotification } from "../../../../../utils/notifications";
import { getTotalPassAsistencias } from "../../../../actions/totalPass";
import TabInfoModal from "../../../../components/common/tableInfoModal/tableInfoModal";
import { PaymentMovement } from "../../../paymentMovements";
import {
  TabAccesosDispatcher,
  tabBitacoraDispatcher
} from "./TabAccesos.dispatcher";
import { tabAccesosStore, TabAccesosStore } from "./TabAccesos.store";

function formatDate(date: string, time: string): string {
  try {
    const [year, month, day] = date.split("-");

    // Formato de la fecha:
    const fmtDate = `${day}/${month}/${year} `;
    const indexSeconds = time.lastIndexOf(":");
    const fmtTime = indexSeconds >= 4 ? time.substring(0, indexSeconds) : time;

    return fmtDate + fmtTime;
  } catch (error) {
    return (date || "") + " " + (time || "");
  }
}

interface Props extends TabAccesosStore, TabAccesosDispatcher {
  detalle: InvitadoDetalle;
}

interface State {
  showCreditNotes: boolean;
  row: PaymentMovement;
  isModalOpen: boolean;
  modalData: any[];
  accesos: any[];
  wait: boolean;
}

@ReduxConnect(tabAccesosStore, tabBitacoraDispatcher)
export default class TabAccesos extends Component<Props, State> {
  state: Readonly<State> = {
    showCreditNotes: false,
    row: null as PaymentMovement,
    isModalOpen: false,
    modalData: [],
    accesos: [],
    wait: false
  };

  componentDidMount() {
    this.props.getClubesAccesoTotalPass(this.props.detalle.idPersona);
    this.cargarInvitadoAccesosAClub();
  }

  handleSchedulePatternDetailView = data => {
    this.setState({ modalData: data, isModalOpen: true });
  };

  cargarInvitadoAccesosAClub = () => {
    this.setState({
      wait: true
    });

    getTotalPassAsistencias(this.props.detalle.idPersona)
      .then(response => {
        const accesos = response.data;

        accesos.forEach(socio => {
          socio.asistencias.forEach(asistencia => {
            asistencia.fechaFormat = formatDate(
              asistencia.fecha,
              asistencia.hora
            );
          });
        });

        this.setState({
          accesos: accesos,
          wait: false
        });
      })
      .catch(err => {
        errorNotification("No se pudieron consultar los accesos");
        this.setState({
          accesos: null,
          wait: false
        });
      });
  };

  render() {
    return (
      <Container>
        <TabInfoModal
          title="Detalle de horario de acceso"
          message={""}
          isOpen={this.state.isModalOpen}
          size="md"
          columns={[
            {
              Header: "DIA",
              id: "horarioDiaSemana",
              accessor: "diaSemana"
            },
            {
              Header: "Entrada",
              id: "horarioEntrada",
              accessor: "horarioEntrada"
            },
            {
              Header: "Salida",
              id: "horarioSalida",
              accessor: "horarioSalida"
            }
          ]}
          data={this.state.modalData}
          close={() => {
            this.setState({ isModalOpen: false, modalData: [] });
          }}
        />

        <div>
          <p className={`primaryTitle w-100 m-0 mt-4`}>
            Configuración de acceso a clubes por integrante
          </p>
        </div>

        <div className="mt-3">
          <ReactTable
            className=" -striped -highlight"
            data={this.props.clubesAccesoInvitado || []}
            columns={[
              {
                Header: "Integrante",
                id: "clubAccessIntegrante",
                accessor: "personaNombre",
                className: "text-wrap",
                width: "300"
              },
              {
                Header: "Patrón de horario",
                id: "clubAccessPatron",
                accessor: "patronHorarioNombre",
                className: "text-center",
                width: "150"
              },
              {
                Header: "",
                className: "text-center",
                width: "60",
                Cell: row => {
                  const { horarioDetalle } = row.original;
                  return (
                    <div>
                      <BaseButtonWithIconAndTooltip
                        id={`showSchedulePatternDetail_${row.original.personaId}${row.original.patronHorarioId}`}
                        icon={faArrowRight}
                        color={"#077"}
                        toolTipPlacement={"right"}
                        tooltipTitle={"Ver detalle de patrón de horario"}
                        onClick={() => {
                          this.handleSchedulePatternDetailView(horarioDetalle);
                        }}
                      />
                    </div>
                  );
                }
              },
              {
                Header: "Tipo",
                id: "clubAccessTipo",
                accessor: "tipo",
                width: "250"
              },
              {
                Header: "Clubes",
                id: "clubAccessClubes",
                accessor: "clubes",
                className: "text-wrap",
                width: "800"
              }
            ]}
            sortable={false}
            resizable={false}
            showPagination={false}
            pageSize={(this.props.clubesAccesoInvitado || []).length + 1}
          />
        </div>

        <div>
          <p className={`primaryTitle w-100 m-0 mt-4`}>
            Información de accesos a clubes
          </p>
        </div>

        {!!this.state.wait && (
          <div className="mt-3">
            <p className="mt-3" style={{ fontSize: "1em" }}>
              Espere un momento por favor &nbsp;
              <FontAwesomeIcon
                icon={faSpinner}
                style={{ color: "#444" }}
                pulse={true}
              />
            </p>
          </div>
        )}

        <div className="mt-3">
          {(this.state.accesos || []).map(socio => (
            <>
              <div className="mt-3">
                ({socio.idPersona}) {socio.persona}
              </div>
              <ReactTable
                key={socio.idPersona}
                className=" -striped -highlight"
                data={socio.asistencias || []}
                columns={[
                  {
                    Header: "Club",
                    id: "club",
                    accessor: "club"
                  },
                  {
                    Header: "Fecha",
                    id: "fechaFormat",
                    accessor: "fechaFormat"
                  },
                  {
                    Header: "Tipo",
                    id: "tipo",
                    accessor: "tipo"
                  },
                  {
                    Header: "Mensaje",
                    id: "message",
                    accessor: "message"
                  }
                ]}
                sortable={false}
                resizable={false}
                pageSize={
                  socio.asistencias && socio.asistencias.length > 5
                    ? socio.asistencias.length
                    : 5
                }
                showPagination={false}
                loading={this.state.wait}
              />
            </>
          ))}
        </div>
      </Container>
    );
  }
}
